import { createAction } from '@reduxjs/toolkit';

/**
 * The line an ambiguous code was, chosen on the phone; its payload is the
 * draft the quantity step counts. Apart from the slice because a thunk sends
 * it too, and the slice imports the thunks.
 */
export const receivingLineChosen = createAction('operatorReceiving/lineChosen');

/**
 * A count that goes over what its line lacks, held on the phone until the
 * operator confirms it. Payload: `{arg, excess}` — the count, and its lines
 * as the 409 `over_receipt` lists them.
 */
export const receivingExcessFound = createAction('operatorReceiving/excessFound');
